<template>
  <Layout hide-bottom-nav-bar>
    <template #center-content>
      <BaseCard
        class="neutral tone-100 px-0"
        hide-divider
      >
        <template #header>
          <router-link to="/courses" class="mt-6  d-flex align-center text-decoration-none">
            <BaseButton
              :ripple="false"
              depressed
              color="transparent"
              :height="32"
              class="px-0"
            >
              <font-awesome-icon
                :icon="$vuetify.breakpoint.mdAndDown ?
                  'fa-regular fa-arrow-left': 'fa-regular fa-arrow-left-long'"
                :class="$vuetify.breakpoint.mdAndDown ? 'brand-secondary--text' : 'neutral--text'"
                size="lg"
              />
            </BaseButton>
            <div
              :class="$vuetify.breakpoint.mdAndDown ?
                'brand-secondary--text text-body-m' : 'neutral--text text-label-s-semi-bold'"
              @click="openDialog = false"
            >
              Tous les cours
            </div>
          </router-link>
        </template>

        <template #content>
          <div class="px-6">
            <div class="mb-10">
              <BaseHeader
                class="mt-6 mb-6 mt-md-2 mb-md-4 text-center text-md-left"
                :class="$vuetify.breakpoint.mdAndDown ? 'neutral--text' :
                  'brand-secondary--text text--tone-400'"
              >
                <span> Finalisation </span>
              </BaseHeader>
            </div>

            <BaseSubheader class="brand-primary--text text--tone-400 mb-6 text-center text-md-left">
              {{ $t('Your subscription request has been confirmed') }}.
            </BaseSubheader>

            <BaseHeaderDescription class="mb-6 text-center text-md-left">
              <span class="neutral--text text--tone-400">
                {{ $t('You can follow its status by checking your subscriptions') }}
              </span>
            </BaseHeaderDescription>

            <BaseHeaderDescription class="mb-6 text-center text-md-left">
              <span class="neutral--text text--tone-400">
                {{ $t('In the meantime, you can complete your profile') }}
              </span>
            </BaseHeaderDescription>

            <div>
              <BaseButton
                color="brand-primary tone-400"
                class="white--text"
                @click="$router.push('/profile')"
                :block="$vuetify.breakpoint.mdAndDown"
              >
                {{ $t('Complete my profile') }}
              </BaseButton>
            </div>

          </div>
        </template>
      </BaseCard>
    </template>
  </Layout>
</template>

<script>
import Layout from '@/views/containers/Layout.vue';
import BaseCard from '@/components/BaseCard.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseHeader from '@/components/BaseHeader.vue';
import BaseHeaderDescription from '@/components/BaseHeaderDescription.vue';
import BaseSubheader from '@/components/BaseSubheader.vue';

export default {
  name: 'SubscriptionConfirmed',
  components: {
    Layout,
    BaseCard,
    BaseButton,
    BaseHeader,
    BaseHeaderDescription,
    BaseSubheader,
  },
};
</script>
